import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    right: '1rem',
    top: '50%',
    display: 'flex',
    alignItems: 'center',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
    fontSize: theme.size.base,
    color: 'grey'
  }
}))

export default useStyles
